document.addEventListener('DOMContentLoaded', function() {
  function refreshHeaderCart() {
    // Fetch the freshly updated header from Shopify
    // We get the section ID dynamically by looking at the header component
    const headerSection = document.querySelector('.header-section');
    if (!headerSection) return;
    
    // We assume the ID is in the DOM or we can fetch the current URL
    let sectionId = 'header';
    if (headerSection.id) {
      const sectionIdMatch = headerSection.id.match(/shopify-section-(.+)/);
      if (sectionIdMatch) sectionId = sectionIdMatch[1];
    } else {
      // Look for a Shopify section marker
      const marker = headerSection.closest('[id^="shopify-section-"]');
      if (marker) {
        sectionId = marker.id.replace('shopify-section-', '');
      }
    }

    fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find and swap all cart bubbles
        const newBubbles = doc.querySelectorAll('.cart-bubble');
        const currentBubbles = document.querySelectorAll('.cart-bubble');
        currentBubbles.forEach((bubble, index) => {
          if (newBubbles[index]) bubble.outerHTML = newBubbles[index].outerHTML;
        });

        // Update cart items in the drawer
        const currentItems = document.querySelector('.cart-drawer__items');
        const newItems = doc.querySelector('.cart-drawer__items');
        if (currentItems && newItems) currentItems.innerHTML = newItems.innerHTML;

        // Update cart summary in the drawer
        const currentSummary = document.querySelector('.cart-drawer__summary');
        const newSummary = doc.querySelector('.cart-drawer__summary');
        if (currentSummary && newSummary) currentSummary.innerHTML = newSummary.innerHTML;

        // Update cart total price in header
        const currentPrice = document.querySelector('.cart-total-price');
        const newPrice = doc.querySelector('.cart-total-price');
        if (currentPrice && newPrice) currentPrice.innerHTML = newPrice.innerHTML;
        
        // Remove empty state classes if they exist
        const cartDrawerInner = document.querySelector('.cart-drawer__inner');
        const cartDrawerDialog = document.querySelector('.cart-drawer__dialog');
        if (cartDrawerInner) cartDrawerInner.classList.remove('cart-drawer--empty');
        if (cartDrawerDialog) cartDrawerDialog.classList.remove('cart-drawer--empty');
      })
      .catch(err => console.error('Error updating cart icon:', err));
  }

  // Intercept Fetch API (used by most modern themes and apps)
  const originalFetch = window.fetch;
  window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);
    const url = arguments[0];
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear'))) {
      // Wait a tiny bit for the backend to catch up, then refresh the icon
      setTimeout(refreshHeaderCart, 250);
    }
    return response;
  };

  // Intercept standard AJAX requests (used by older apps)
  const originalOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear'))) {
        setTimeout(refreshHeaderCart, 250);
      }
    });
    return originalOpen.apply(this, arguments);
  };
});
